var _rect, _path, _path2, _path3, _path4, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageEnhancer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#A658FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.499 13.002L19.5654 10.4346L16.998 9.50098L19.5654 8.56738L20.499 6L21.4326 8.56738L24 9.50098L21.4326 10.4346L20.499 13.002Z",
    fill: "#F8DA78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.332 18L29.2654 15.0667L26.332 14L29.2654 12.9333L30.332 10L31.3987 12.9333L34.332 14L31.3987 15.0667L30.332 18Z",
    fill: "#F8DA78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22L10.0667 24.9333L13 26L10.0667 27.0667L9 30L7.93333 27.0667L5 26L7.93333 24.9333L9 22Z",
    fill: "#F8DA78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8336 24L18.5892 26.0778L20.667 26.8334L18.5892 27.5889L17.8336 29.6667L17.0781 27.5889L15.0002 26.8334L17.0781 26.0778L17.8336 24Z",
    fill: "#F8DA78"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4346,
    y: 9,
    width: 31.8307,
    height: 5.19724,
    rx: 1,
    transform: "rotate(41.3672 11.4346 9)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9209,
    y: 16.3633,
    width: 5.20417,
    height: 2,
    transform: "rotate(-48.7932 11.9209 16.3633)",
    fill: "#A658FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEnhancer);
export default __webpack_public_path__ + "static/media/image-enhancer.0e9299371f821fb8baa76df88c0eef0b.svg";
export { ForwardRef as ReactComponent };